import { render, staticRenderFns } from "./Wysiwyg.vue?vue&type=template&id=a5986a84"
import script from "./Wysiwyg.vue?vue&type=script&lang=js"
export * from "./Wysiwyg.vue?vue&type=script&lang=js"
import style0 from "./Wysiwyg.vue?vue&type=style&index=0&id=a5986a84&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports